/*
  Barre d'achat collante. Elle ne contient aucun formulaire : son bouton soumet
  le formulaire produit principal (attribut form=), et son état est recopié
  depuis le bouton et le prix principaux, mis à jour par product-info.js.
*/
if (!customElements.get('mci-sticky-atc')) {
  customElements.define(
    'mci-sticky-atc',
    class MciStickyAtc extends HTMLElement {
      connectedCallback() {
        const sectionId = this.dataset.section;
        this.form = document.getElementById(`product-form-${sectionId}`);
        this.mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
        this.mainPrice = document.getElementById(`price-${sectionId}`);
        if (!this.form || !this.mainButton) return;

        this.button = this.querySelector('[data-sticky-button]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.variantTitle = this.querySelector('[data-sticky-variant]');
        this.customLabel = this.dataset.label;

        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-visible', !entry.isIntersecting);
        });
        this.visibilityObserver.observe(this.form);

        this.mutationObserver = new MutationObserver(() => this.sync());
        this.mutationObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        if (this.mainPrice) {
          this.mutationObserver.observe(this.mainPrice, { attributes: true, childList: true, subtree: true });
        }

        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== sectionId || !this.variantTitle) return;
            const title = data.variant && data.variant.title !== 'Default Title' ? data.variant.title : '';
            this.variantTitle.textContent = title;
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.unsubscribe?.();
      }

      sync() {
        const disabled = this.mainButton.hasAttribute('disabled');
        this.button.disabled = disabled;
        const mainLabel = this.mainButton.querySelector('span:not(.hidden)')?.textContent.trim();
        this.label.textContent = !disabled && this.customLabel ? this.customLabel : mainLabel;

        if (this.mainPrice && this.price) {
          this.price.innerHTML = this.mainPrice.innerHTML;
          this.price.classList.toggle('hidden', this.mainPrice.classList.contains('hidden'));
        }
      }
    }
  );
}
